export class RealBeadImageModel {
static realBeadImages: string[][] = [["DB0080","DB0042","DB0281","DB0726","DB0083"],["DB0727","DB1363","DB0723","DB0722","DB0654"],["DB1832","DB0747","DB1459","DB0141","DB0751"],["DB0354","DB2034","DB0757","DB2035","DB0203"],["DB0217","DB0389","DB0214","DB0201","DB0215"],["DB0022L","DB0239","DB1132","DB0010","DB1793"],["DB0249","DB0659","DB1790","DB1347","DB0310"]];
static width : number = 83;
static height : number = 58;
static padding : number = 3;
}
